"use client";

import { useEffect } from "react";
import styles from "./OurStoryItems.module.css";
import { OUR_STORY } from "@/utils/utilsAbout";

function OurStoryItems() {
  useEffect(() => {
    const items = document.querySelectorAll(`.${styles.item}`);

    // IntersectionObserver options
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.95, // Trigger when 95% of the item is in view
    };

    // Observer callback
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add active class with stagger delay
          entry.target.style.setProperty("--index", entry.target.dataset.index);
          entry.target.style.setProperty("--stagger-delay", 0.2); // Adjust delay between items
          entry.target.classList.add(styles.active);
        }
      });
    }, options);

    // Set data-index on each item and observe
    items.forEach((item, index) => {
      item.dataset.index = index + 1; // Assign index for delay calculation
      observer.observe(item);
    });

    // Cleanup observer on component unmount
    return () => {
      items.forEach((item) => observer.unobserve(item));
    };
  }, []);

  return (
    <div className={styles.items}>
      {OUR_STORY.map((item, index) => (
        <div className={styles.item} key={item.id}>
          {index > 2 && <div className={item.rowSpace} />}

          {item.title ? (
            <>
              <div className={styles.itemIcons}>
                {item.icon}
                {item?.stroke ? item.stroke : null}
              </div>
              <div className={styles.itemContentContainer}>
                <div className={styles.itemContent}>
                  <p>{item.year}</p>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>

                <div className={styles.columnSpace} />
              </div>
            </>
          ) : (
            <div>{item.stroke}</div>
          )}
        </div>
      ))}
    </div>
  );
}

export default OurStoryItems;
